import { Button, Icon } from "@pepperstone/pepper-ui-kit";

import { Locale } from "./locales";

export type OptionProps = {
  isSelected: boolean;
  locale: Locale;
  onChange: (locale: Locale) => void;
  toggleOptionsVisibility: () => void;
};

export const Option = ({
  isSelected,
  locale,
  onChange,
  toggleOptionsVisibility,
}: OptionProps) => {
  const handleLanguageSelect = (locale: Locale) => {
    onChange?.(locale);
    toggleOptionsVisibility();
  };

  return (
    <li className="w-full">
      <Button
        type="button"
        className={`relative w-full !justify-start ${isSelected ? "" : "!bg-white"}`}
        onClick={() => handleLanguageSelect(locale)}
        onKeyDown={() => handleLanguageSelect(locale)}
      >
        <div className="flex items-center">
          <span>{locale.label ?? locale.code}</span>
          {isSelected && (
            <span className="absolute end-4 me-0 ms-auto text-text-success">
              <Icon icon="check-mark" size={10} />
            </span>
          )}
        </div>
      </Button>
    </li>
  );
};
